import { Component, OnDestroy, OnInit } from '@angular/core';
import {
    IColorBandObject,
    IColoumnSelectionInfo,
    IDataParameters,
    IDataParametersOnlyRequired,
    IDataPropertiesOnlyRequired,
    IDynamicColumnsMapping,
    IReportEditData,
    IReportPageProperties,
    ISelectedColumns,
    ISortDescriptorCustom,
    ITableColumns,
} from '../../interfaces/reporting-data';
import { IPageHeadline, PageTitleParameters } from '../../../shared/classes/page-title-parameters';
import { ReusableFunctions } from '../../../shared/classes/reusable-functions';
import {
    DisplayOptions,
    IDisplayOptionToReset,
    IOptionalSummaryList,
    ISummaryAreaInfo,
} from '../../../shared/interfaces/display-options';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ReportingService } from '../../services/reporting.service';
import { IReportingCommon } from '../../interfaces/reporting-common-for-allcomponent';
import { LoanDetailsListOfLoansService } from '../../../shared/loan-details-modal/loan-details-list-of-loans.service';
import { NoDataActionType } from '../../../shared/interfaces/no-data';
import { BookmarkService } from '../../../shared/services/bookmark.service';
import { formatDate } from '@angular/common';
import { UserAccessService } from '../../../shared/services/user-access.service';
import { saveAs } from 'file-saver';
import { DisplayOptionsService } from '../../../shared/services/display-options.service';
import { MatDialog } from '@angular/material/dialog';
import { ScheduleReportBuilderComponent } from '../../../shared/components/schedule-report-builder/schedule-report-builder.component';
import { ReportExportService } from '../../../shared/services/report-export.service';
import { ReportEditDialogComponent } from 'app/modules/reports/components/report-edit-dialog/report-edit-dialog.component';
import { ToastService } from 'app/modules/shared/services/toast.service';
import { HttpHeaders } from '@angular/common/http';
import {
    ICellClickEventInfo,
    ICustomTableInfoExtend,
    IFooterObject,
} from 'app/modules/shared/components/custom-mat-table/custom-mat-table.component';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';

@Component({
    selector: 'app-reporting',
    templateUrl: './reporting.component.html',
    styleUrls: ['./reporting.component.scss'],
})
export class ReportingComponent implements OnInit, OnDestroy {
    constructor(
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _reportingService: ReportingService,
        private _reusableFunctions: ReusableFunctions,
        private _listOfLoansService: LoanDetailsListOfLoansService,
        private _bookmarkService: BookmarkService,
        private _displayOptionsService: DisplayOptionsService,
        private _userAccessService: UserAccessService,
        private _dialog: MatDialog,
        private _reportExportService: ReportExportService,
        private _toastService: ToastService
    ) {
        this._reportExportService.downloadFinished.subscribe((id) => {
            if (id && this.requiredProperties) {
                if (id == this.requiredProperties.reportId) {
                    this.downloadingExcel = false;
                }
            }
        });
    }

    urlSegment: string;
    pageHeadline?: IPageHeadline;
    columnsProperties: ITableColumns[];
    columnsPropertiesOriginal: ITableColumns[];
    pageProperties: IReportPageProperties;
    moduleName: string;
    reportName: string;
    searchedValue: string = '';
    pageSize: number = 10;
    skip = 0;
    height = 680;
    exportFileName: string;
    exportPdfFileName: string;
    gridData: IReportingCommon[];
    sort: ISortDescriptorCustom[];
    showSummary: boolean;
    showDisplayOptionsEditButton: boolean;
    optionalSummaryList: IOptionalSummaryList[];
    reportUrl: string = '';
    previousUrl: string = '';
    fromRouteDisplayOptionParameters: IOptionalSummaryList[];
    bookmarkColumnInfo: ITableColumns;
    clickedLoanInfoRow: { rowData: IReportingCommon; rowInfo: ITableColumns };
    exportHeaderSummaryData: ISummaryAreaInfo[];
    bandColorList: IColorBandObject[];
    hasData: boolean;
    totalRows: number;
    hasDisplayOptChange: boolean;
    displayOptionsToReset: IDisplayOptionToReset[];
    requiredProperties: IDataPropertiesOnlyRequired;
    dynamicColumnInfoList: IDynamicColumnsMapping[];
    isInitialLoading: boolean;
    calculateAggregationAws: boolean;
    calculateAggregation: boolean;
    hideExcelExport = false;
    hidePdfExport = true;
    downloadingExcel = false;
    downloadingExcel_1 = false;
    downloadingTestExport = false;
    finAAGModalPage = false;
    hardDateRange: string;
    clientShortName = '';
    currentUserName = '';
    headers: HttpHeaders;
    baseApiUrl: string;
    columnNameList: string[];
    isFirstDataRequest: '0' | '1' | '-1';
    redisId: string;
    customTableInfo: ICustomTableInfoExtend;
    footerObject: IFooterObject;
    action: NoDataActionType;
    timeOutHolder: any;

    ngOnInit() {
        scroll(0, 0);
        this.action = NoDataActionType.pageStart;
        this.gridData = [];
        this.pageHeadline = {
            pageTitle: '',
            linkArray: [],
            linkTitle: '',
            module: '',
            moduleIcon: '',
            moduleLink: '',
        };
        this.isFirstDataRequest = '1';
        this.redisId = this._reusableFunctions.getGuid();
        this.hasData = false;
        this.optionalSummaryList = [];
        this.fromRouteDisplayOptionParameters = [];
        this.showDisplayOptionsEditButton = false;
        this.hasDisplayOptChange = false;
        this.checkForLoanDetailsDialogChange();
        this.loadPageProperties();
    }

    initializeCustomTable() {
        this.customTableInfo = {
            tableId: 'reporting-module-table',
            tableHeight: 630,
            hasData: false,
            isDataReady: false,
            columnInfoList: this.columnsProperties,
            dataSet: [],
            searchTerm: this.searchedValue,
            action: this.action,
            title: this.pageHeadline.pageTitle,
            bandColorList: [],
            dataHandleInUiSide: false,
            showSummary: true,
            paginationOptions: {
                totalRecords: 0,
                pageSizeOptions: [10, 20, 50, 100, 150],
                pageSize: 0,
            },
        };
    }

    loadPageProperties() {
        this.isInitialLoading = true;
        this.calculateAggregation = true;
        this.calculateAggregationAws = true;
        this.skip = 0;
        this.showSummary = false;
        this.columnsProperties = [];
        this.columnsPropertiesOriginal = [];
        this.initializeCustomTable();
        this.getUrlSegments();
        let routerParams = this.getRouterParameters();
        this.hardDateRange = routerParams.dateRange ? routerParams.dateRange : '';
        // todo: make dynamic/generic way to get routerParams['staffingId']
        this._reportingService
            .getDataProperties(
                this.moduleName,
                this.reportName,
                routerParams['ownerPosition'],
                routerParams['staffingId']
            )
            .subscribe({
                next: (pageProperties) => {
                    if (pageProperties) {
                        this.pageProperties = pageProperties;
                        this.columnsPropertiesOriginal = this.pageProperties.columnsProperties;
                        this.previousUrl = routerParams['navFromUrl'];
                        this.getPageHeadLine(routerParams['titleSuffix']);
                        this.showDisplayOptionsEditButton =
                            this.pageProperties.showDisplayoptionsEditButton;
                        this.bandColorList = this.pageProperties.bandColors;
                        this.setPageProperties();
                        this.setColumnProperties();
                        this.checkAccessThenGetData();
                        if (this.finAAGModalPage) this.showDisplayOptionsEditButton = false;
                    } else {
                        this.gridData = [];
                    }
                },
                error: (err) => {
                    this.action = NoDataActionType.error;
                },
            });
    }

    checkAccessThenGetData() {
        if (this._userAccessService.hasAccessToPage(this.reportUrl)) {
            this.setRequiredDataPropertiesThenGeData();
        } else {
            this.action = NoDataActionType.lock;
        }
    }

    // setClientShortName() {
    //     let currentUserInfo = this._reportingService.getCurrentUserInfo();
    //     this.clientShortName = currentUserInfo.clientShortName;
    //     this.currentUserName = currentUserInfo.currentUserName;
    // }

    setRequiredDataPropertiesThenGeData() {
        if (this.pageProperties && this.pageProperties.dataParameters) {
            // let columnsInfoToDisplayDynamicaly = this.columnsProperties.filter(
            //     (col) => col.hideColumnIfAllDataNull === true
            // );

            // TODO: Check for impersonate client??

            this.requiredProperties = {
                moduleId: this.moduleName,
                reportId: this.reportName,
                searchTerm: this.searchedValue,
                pageSize: this.pageSize,
                topLimit: this.skip,
                sortByList: this.sort,
                dynamicColumnList: this.dynamicColumnInfoList,
                parameters: [],
                clientShortName: this.clientShortName,
                isFirstDataRequest: this.isFirstDataRequest,
                bucketId: this.redisId,
                loginEmail: this.currentUserName,
                activeColumnList: this.columnNameList,
                hasDownloadRequested: false,
            };

            this.customTableInfo.dataSet = [];
            this.customTableInfo.paginationOptions.totalRecords = 0;
            this.customTableInfo = this._reportingService.refreshCustomMatTable(
                this.customTableInfo,
                false,
                false,
                this.action,
                this.searchedValue
            );

            if (this.finAAGModalPage) {
                const ymcIndex = this.pageProperties.dataParameters.findIndex(
                    (e) => e.filterKey === 'ymc'
                );
                const loanAccountIndex = this.pageProperties.dataParameters.findIndex(
                    (e) => e.filterKey === 'loanAccount'
                );

                if (ymcIndex > 0 && !this.pageProperties.dataParameters[ymcIndex]?.value) {
                    this.pageProperties.dataParameters.splice(ymcIndex, 1);
                }
                if (
                    loanAccountIndex > 0 &&
                    this.pageProperties.dataParameters[loanAccountIndex]?.value === '2'
                ) {
                    this.pageProperties.dataParameters.splice(loanAccountIndex, 1);
                }
            }
            this.pageProperties.dataParameters.forEach((para) => {
                if (!para.isNotDataProp) {
                    this.requiredProperties.parameters.push({
                        parameter: para.parameter,
                        value: para.value ? para.value : '',
                    });
                }
            });

            if (this.bookmarkColumnInfo) {
                this._bookmarkService.getBookmarksJson().subscribe((allBookmarks: string) => {
                    let parameter = this.pageProperties.dataParameters.find(
                        (item) => item.filterKey === 'bookmark'
                    );

                    if (parameter) {
                        let bookMarkInf: IDataParametersOnlyRequired =
                            this.requiredProperties.parameters.find(
                                (item) => item.parameter === parameter.parameter
                            );
                        if (bookMarkInf) {
                            bookMarkInf.value = allBookmarks;
                        }
                    }
                    //this.getReportDataThroughDirectApi();
                    this.getReportData();
                });
            } else {
                //this.getReportDataThroughDirectApi();
                this.getReportData();
            }
        }
    }

    getRouterParameters() {
        return Object.assign({}, this._activatedRoute.snapshot.queryParams);
    }

    setPageProperties(displayOptions?: DisplayOptions[]) {
        this.fromRouteDisplayOptionParameters = [];
        if (this.pageProperties) {
            // NOTE: Url parameters that can be passed to DD component:
            // navFromUrl: the url refering from
            // titleSuffix: the string to append the DD page title
            // showOnlyPreviusDateRange: show only the previous period date range and hide other date ranges
            let routerParams = this.getRouterParameters();
            let dataProperties = this.pageProperties.dataParameters;
            if (dataProperties) {
                let hFilterParam = dataProperties.find(
                    (item) => item.getFromHierarchyFilters === true
                );
                if (hFilterParam) {
                    let hFilterJSON = this._reusableFunctions.getHierarchyFilters();
                    hFilterParam.value = hFilterJSON;
                }

                if (!displayOptions) {
                    displayOptions = this._reusableFunctions.getCurrentDisplayOptions(
                        this.reportUrl
                    );
                }

                if (displayOptions.length > 0) {
                    for (let sParam of dataProperties) {
                        if (sParam.filterKey && !sParam.getFromRoute && !sParam.getFromComponent) {
                            let displayOptionItem = displayOptions.find(
                                (x) => x.optionKey == sParam.filterKey
                            );
                            if (displayOptionItem) {
                                if (displayOptionItem.isMultiSelection) {
                                    this.displayOptionsSpecialHandling(sParam, displayOptionItem);
                                } else {
                                    if (sParam.filterKey === 'yearsDdl') {
                                        sParam.value = displayOptionItem.selectedOptionsFriendly;
                                    } else {
                                        sParam.value = displayOptionItem.selectedOptions;
                                    }
                                }
                            }
                        }
                    }
                }

                this.pageProperties.dataParameters.forEach((prm) => {
                    let routerParamsValue = routerParams[prm.filterKey];
                    if (prm.getFromRoute) {
                        prm.value = routerParamsValue
                            ? routerParamsValue
                            : prm.value
                            ? prm.value
                            : '';
                    }
                });
                this.setDisplayOptionsDatePeriod(displayOptions, routerParams);
                this.setCustomDateRangeParameters(displayOptions);
            }
        }
    }

    setCustomDateRangeParameters(displayOptions: DisplayOptions[]) {
        // Note: This logic assumes only one date-range option is available for the page
        let dataProperties = this.pageProperties.dataParameters;
        let dateDisplayOptionItem = displayOptions.find((x) => x.isUsedForGetDateRange === true);

        let mainDaterangeParam = dataProperties.find(
            (itm) => itm.filterKey === dateDisplayOptionItem?.optionKey
        );
        let startDateParam = dataProperties.find(
            (itm) => itm.parameter.toLowerCase() === 'startdate'
        );
        let endDateParam = dataProperties.find((itm) => itm.parameter.toLowerCase() === 'enddate');

        if (
            dateDisplayOptionItem &&
            dateDisplayOptionItem.dateRange &&
            dateDisplayOptionItem.dateRange.length > 0
        ) {
            let dateRangeArray = dateDisplayOptionItem.dateRange;
            let startDate = dateRangeArray[0].dateValueFrom;
            let endDate = dateRangeArray[0].dateValueTo;

            if (dateDisplayOptionItem.dateRangeType === 'custom') {
                if (mainDaterangeParam) {
                    mainDaterangeParam.value = 'Custom';
                    if (!startDateParam) {
                        startDateParam = Object.assign({}, mainDaterangeParam);
                        startDateParam.parameter = 'StartDate';
                        dataProperties.push(startDateParam);
                    }

                    if (!endDateParam) {
                        endDateParam = Object.assign({}, mainDaterangeParam);
                        endDateParam.parameter = 'EndDate';
                        dataProperties.push(endDateParam);
                    }
                }
            } else if (dateDisplayOptionItem.dateRangeType === 'standard') {
                startDate = '';
                endDate = '';
            }

            if (startDateParam) {
                startDateParam.value = startDate;
            }

            if (endDateParam) {
                endDateParam.value = endDate;
            }
        }
    }

    setDisplayOptionsDatePeriod(displayOptions: DisplayOptions[], routerParams: Params) {
        // TODO: Find a better way to move 'selectedperiod' and 'periodgroup' database.
        // Until then, these two values should be same for all the reports that use these values.
        let selectedperiodParamName = 'selectedPeriod';
        let selectedPeriodInRouterParams = routerParams[selectedperiodParamName];
        let dataParms = this.pageProperties.dataParameters;
        let selectedPeriodInDataParams = dataParms.find(
            (item) =>
                item.filterKey &&
                item.filterKey.toLowerCase() === selectedperiodParamName.toLowerCase()
        );

        if (!selectedPeriodInDataParams && selectedPeriodInRouterParams) {
            dataParms.push({
                parameter: selectedperiodParamName,
                filterKey: selectedperiodParamName,
                value: selectedPeriodInRouterParams,
                isNotDataProp: true,
            });
        }

        dataParms.forEach((prm) => {
            if (prm && prm.filterKey) {
                if (
                    this.hasDisplayOptChange &&
                    prm.filterKey.toLowerCase() === selectedperiodParamName.toLowerCase()
                ) {
                    // NOTE: Purpose of this area is to reset the displayoption items that get from router
                    // when displayoption menu is changed from the drildown report page.
                    let dateDispOpt = displayOptions.find((item) => item.isUsedForGetDateRange);
                    if (dateDispOpt) {
                        this.displayOptionsToReset = [
                            {
                                optionKey: dateDispOpt.optionKey,
                                toBeSetValue: dateDispOpt.selectedOptions,
                            },
                        ];
                    }
                    // TODO: remove selectedPeriod from this.pageProperties.dataParameters
                    // AND/OR update router parameters accordingly
                    prm.value = '';

                    // TODO remove this check after adding 'selectedperiod' and
                    // removing month and year from incentives drilldown sprocs
                    if (this.moduleName === 'financials') {
                        let monthParam = dataParms.find(
                            (item) => item.filterKey && item.filterKey.toLowerCase() === 'month'
                        );
                        let yearParam = dataParms.find(
                            (item) => item.filterKey && item.filterKey.toLowerCase() === 'year'
                        );
                        if (monthParam) {
                            monthParam.value = '';
                        }
                        if (yearParam) {
                            yearParam.value = '';
                        }
                    }
                    this.hasDisplayOptChange = false;
                }

                this.fromRouteDisplayOptionParameters.push({
                    value: prm.value,
                    title: prm.filterKey,
                });

                if (
                    prm.filterKey.toLowerCase() === 'periodgroup' &&
                    prm.value.toLowerCase() === 'c'
                ) {
                    this.fromRouteDisplayOptionParameters.push({
                        value: 'true',
                        title: 'showOnlyPreviousDateRange',
                    });
                }
            }
        });
    }

    displayOptionsSpecialHandling(sprocParam: IDataParameters, displayoptionItem: DisplayOptions) {
        if (displayoptionItem) {
            sprocParam.value = sprocParam.isBooleanType ? '0' : displayoptionItem.selectedOptions;
            if (displayoptionItem.selectedOptionList) {
                for (let item of displayoptionItem.selectedOptionList) {
                    if (item.optionName === sprocParam.parameter) {
                        sprocParam.value = sprocParam.isBooleanType ? '1' : item.friendlyName;
                    }
                }
            }
        }
    }

    setColumnProperties() {
        this.dynamicColumnInfoList = [];
        this.columnNameList = [];
        this.columnsProperties = this.columnsPropertiesOriginal.filter((col) => col.isSelected);

        let bookmarkColumn = this.columnsProperties.find(
            (col) => col.fieldId === 'bookmark' && col.dataType === 'icon'
        );
        if (bookmarkColumn) {
            bookmarkColumn.iconProperties = {
                iconClass: 'far fa-bookmark',
                showIconOnHeader: true,
                iconClassStart: 'far fa-bookmark',
                iconClassChange: 'fas fa-bookmark',
                headerIconClass: 'far fa-bookmark',
                descriptionKey: '',
                setIconByCellValue: true,
                iconToChangeByValue: 'true',
                iconToChangeByKey: bookmarkColumn.fieldId,
            };
            bookmarkColumn.cellClickEventType = 'bookmark';
        }

        if (this.columnsProperties) {
            this.customTableInfo.columnInfoList = this.columnsProperties;
            this.customTableInfo.bandColorList = this.pageProperties.bandColors;
            this.customTableInfo = this._reportingService.refreshCustomMatTable(
                this.customTableInfo,
                false,
                false,
                this.action,
                this.searchedValue
            );

            this.columnsProperties.forEach((colInf) => {
                this.columnNameList.push(colInf.fieldId);
                if (
                    this.pageProperties.dynamicColumnInfo &&
                    this.pageProperties.dynamicColumnInfo.length > 0
                ) {
                    let dynamicColumns = this.pageProperties.dynamicColumnInfo.find(
                        (item) => item.columnName.toLowerCase() === colInf.fieldId.toLowerCase()
                    );

                    if (dynamicColumns) {
                        colInf.fieldName = dynamicColumns.columnDisplayName;
                        let colWidth = colInf.fieldName.length * 9;
                        colInf.width = colWidth < 100 ? 100 : colWidth;

                        this.dynamicColumnInfoList.push({
                            fieldId: colInf.fieldId,
                            fieldName: dynamicColumns.columnDisplayName,
                        });
                    } else if (colInf.isDynamicColumn) {
                        this.columnsProperties = this.columnsProperties.filter(
                            (item) => item.fieldId != colInf.fieldId
                        );
                    }
                }
            });

            this.bookmarkColumnInfo = this.columnsProperties.find(
                (item) => item.fieldId === 'bookmark'
            );

            if (this.columnsProperties.length === 0) {
                this.gridData = [];
                this.totalRows = 0;
            }
            this.columnsProperties.sort((a, b) => a.fieldOrder - b.fieldOrder);
            this.setDataFormatting();
        }
        this.getInitialSorting();
    }

    getUrlSegments() {
        this.reportUrl = this._router.url.split('?')[0];
        this.finAAGModalPage =
            this.reportUrl.includes('revenue-expenses') ||
            this.reportUrl.includes('financials/volume-funded');
        let urlSegments = this.reportUrl.split('/');
        this.moduleName = '';
        this.reportName = '';

        // TODO: Make this section more robust....
        // TODO: Add logic to capture reports coming from custom dashbords
        if (urlSegments[1] === 'reporting' && urlSegments.length >= 4) {
            this.moduleName = urlSegments[2];

            // Remove modal detail from the reportName segment of route
            if (urlSegments[3].includes('modal')) {
                urlSegments[3] = urlSegments[3].split('(')[0];

                this.reportUrl = this.reportUrl.split('(')[0];
            }

            this.reportName = urlSegments[3];
        }
    }

    getPageHeadLine(titleSuffix: string) {
        let moduleName = this.moduleName;
        let pageTitle = this.pageProperties.reportTitle + (titleSuffix ? titleSuffix + ' ' : '');
        let titleInfo = new PageTitleParameters();
        // TODO: Check this logic back and reduce the confusion with page-title-parameters.ts
        // TODO: Add a logic to prevent/minimize adding navFromUrl patameter in router url

        if (this.previousUrl) {
            if (this.previousUrl === '/report-menu') {
                moduleName = 'report-menu';
                pageTitle = this.pageProperties.moduleName + ': ' + pageTitle;
            } else if (this.previousUrl.includes('my-vision')) {
                moduleName = 'my-vision';
            }
        } else {
            this.previousUrl = '';
        }
        this.pageHeadline = titleInfo.pageHeadlines.find((item) => item.moduleId === moduleName);
        this.pageHeadline.pageTitle = pageTitle;

        this.pageHeadline.linkArray.map((link) => {
            if (!link.isHome) {
                if (link.moduleLink.replace(/\//g, '') === this.previousUrl.replace(/\//g, '')) {
                    link.showLink = true;
                    let linkToHide = this.pageHeadline.linkArray.find((item) =>
                        item.hideIf
                            ? item.hideIf.find((innerItem) => innerItem === link.moduleLink)
                            : false
                    );
                    if (linkToHide) {
                        linkToHide.showLink = false;
                    }
                }
            }
        });
    }

    setDataFormatting() {
        this.columnsProperties.forEach((column) => {
            column.dataFormat =
                '1.' + column.decimalPlaces.toString() + '-' + column.decimalPlaces.toString();
            column.headerClass =
                column.fieldId === 'bookmark'
                    ? 'table-header-styles-bookmark'
                    : 'table-header-styles';
        });
    }

    // setAggregationAws() {
    //     let toGetArregateColumnList = this.columnsProperties.filter(
    //         (item) => item.aggregationType != null
    //     );
    //     this.aggregate = {};
    //     this.showSummary = false;
    //     if (toGetArregateColumnList.length > 0) {
    //         this.showSummary = true;
    //         //this.requiredProperties.isFirstDataRequest = '0';
    //         //console.log(this.baseApiUrl);
    //         //this.requiredProperties.bucketId = this.redisId;
    //
    //         this.requiredProperties.bucketId = this.redisId;
    //
    //         if (this.calculateAggregationAws) {
    //             this._reportingService
    //                 .getAggregationDataFromDirectApi(
    //                     this.requiredProperties,
    //                     this.baseApiUrl,
    //                     this.headers
    //                 )
    //                 .subscribe((result) => {
    //                     this.applyAggregation(result);
    //                     // result.forEach(
    //                     //     (agg) => {
    //                     //         let aggObject = {};
    //                     //         aggObject[agg.aggregationType] = agg.value;
    //                     //         this.aggregate[agg.fieldId] = aggObject;
    //                     //
    //                     //         // TODO: Create seperate db table for Aggregatetype to handle the following logic
    //                     //         let aggFiled = this.columnsProperties.find(
    //                     //             (item) => item.fieldId === agg.fieldId
    //                     //         );
    //                     //
    //                     //         if (aggFiled) {
    //                     //             aggFiled.aggregationType = agg.aggregationType;
    //                     //         }
    //                     //     },
    //                     //     (error) => {
    //                     //         throw error;
    //                     //     }
    //                     // );
    //                     this.calculateAggregationAws = true;
    //                 });
    //         }
    //     }
    // }

    // applyAggregation(aggregation: IAggregation[]) {
    //     aggregation.forEach(
    //         (agg) => {
    //             let aggObject = {};
    //             aggObject[agg.aggregationType] = agg.value;
    //             this.aggregate[agg.fieldId] = aggObject;
    //
    //             // TODO: Create seperate db table for Aggregatetype to handle the following logic
    //             let aggFiled = this.columnsProperties.find((item) => item.fieldId === agg.fieldId);
    //
    //             if (aggFiled) {
    //                 aggFiled.aggregationType = agg.aggregationType;
    //             }
    //         },
    //         (error) => {
    //             throw error;
    //         }
    //     );
    // }

    setAggregation() {
        let toGetArregateColumnList = this.columnsProperties.filter(
            (item) => item.aggregationType != null
        );
        //this.aggregate = {};
        this.showSummary = false;
        if (toGetArregateColumnList.length > 0) {
            this.showSummary = true;
            this.resetSummaryLine();
            this._reportingService
                .getAggregationData(this.requiredProperties)
                .subscribe((result) => {
                    this.footerObject = Object.assign({}, { footerSummary: result });

                    // result.forEach(
                    //     (agg) => {
                    //         let aggObject = {};
                    //         aggObject[agg.aggregationType] = agg.value;
                    //         this.aggregate[agg.fieldId] = aggObject;
                    //
                    //         // TODO: Create seperate db table for Aggregatetype to handle the following logic
                    //         let aggFiled = this.columnsProperties.find(
                    //             (item) => item.fieldId === agg.fieldId
                    //         );
                    //
                    //         if (aggFiled) {
                    //             aggFiled.aggregationType = agg.aggregationType;
                    //         }
                    //
                    //         // ////-------
                    //         //
                    //         // this.footerSummary.push({
                    //         //     fieldId: agg.fieldId,
                    //         //     aggValue: agg.value.toString(),
                    //         // });
                    //         // ////-----
                    //     },
                    //     (error) => {
                    //         throw error;
                    //     }
                    // );

                    // this.customTableInfo.footerSummary = this.footerSummary;
                    // this.customTableInfo = this._reportingService.refreshCustomMatTable(
                    //     this.customTableInfo,
                    //     true,
                    //     true,
                    //     NoDataActionType.pageStart,
                    //     this.searchedValue
                    // );

                    this.calculateAggregation = true;
                });
        }
    }

    // getReportDataThroughDirectApi() {
    //     this.isPageLoaded = false;
    //     this.downloadingExcel_1 = false;
    //     this.headers = this._reportingService.setHeaders();
    //     this._reportingService.getApiGatewayUrl().subscribe(
    //         (baseUrl) => {
    //             this.baseApiUrl = baseUrl;
    //             //this.requiredProperties.isFirstDataRequest = '1';
    //
    //             //this.baseApiUrl = "https://38v5o2ud23.execute-api.us-east-2.amazonaws.com/Prod";
    //             this._reportingService
    //                 .getReportDataDirectApi(this.requiredProperties, this.baseApiUrl, this.headers)
    //                 .subscribe(
    //                     (result) => {
    //                         //this.requiredProperties.bucketId = result.bucketId;
    //                         //this.redisId = result?.bucketId ?? '';
    //                         if (result.data && result.data.length > 0) {
    //                             this.gridData = result.data;
    //                             this.totalRows = result.total;
    //                             this.columnsProperties = this.columnsProperties.filter(
    //                                 (colP, i) => {
    //                                     if (
    //                                         result.columnsToHide &&
    //                                         result.columnsToHide.length > 0
    //                                     ) {
    //                                         let colToHide = result.columnsToHide.find(
    //                                             (item) =>
    //                                                 item.toLowerCase() ===
    //                                                 colP.fieldId.toLowerCase()
    //                                         );
    //                                         return colToHide ? false : true;
    //                                     }
    //                                     return true;
    //                                 }
    //                             );
    //
    //                             this.formatDates();
    //                             this.setGridView();
    //                             this.getDisplayOptionsSummaryData();
    //                             this.hasData = true;
    //                             this.isInitialLoading = false;
    //
    //                             if (this.calculateAggregationAws) {
    //                                 // if (
    //                                 //     result?.aggregationCalculated &&
    //                                 //     result?.aggregation &&
    //                                 //     result?.aggregation.length > 0
    //                                 // ) {
    //                                 //     this.applyAggregation(result.aggregation);
    //                                 // } else {
    //                                 //     this.setAggregationAws();
    //                                 // }
    //                                 this.setAggregationAws();
    //                             }
    //                             this.calculateAggregationAws = true;
    //                         } else {
    //                             this.gridData = [];
    //                             this.totalRows = 0;
    //                             this.setGridView();
    //                             this.hasData = false;
    //                             this.isPageLoaded = true;
    //                         }
    //                     },
    //                     (error) => {
    //                         this.hasData = false;
    //                         this.isPageLoaded = true;
    //                         //this.noDataType.action = NoDataActionType.error;
    //                     }
    //                 );
    //         },
    //         (error) => {
    //             this.hasData = false;
    //             this.isPageLoaded = true;
    //             //this.noDataType.action = NoDataActionType.error;
    //         }
    //     );
    // }

    getReportData() {
        this.downloadingExcel = false;
        this._reportingService.getReportData(this.requiredProperties).subscribe(
            (result) => {
                if (result.data && result.data.length > 0) {
                    this.gridData = result.data;
                    this.totalRows = result.total;
                    this.columnsProperties = this.columnsProperties.filter((colP, i) => {
                        if (result.columnsToHide && result.columnsToHide.length > 0) {
                            let colToHide = result.columnsToHide.find(
                                (item) => item.toLowerCase() === colP.fieldId.toLowerCase()
                            );
                            return colToHide ? false : true;
                        }
                        return true;
                    });

                    this.formatDates();
                    this.updateGridView(
                        this.gridData,
                        this.totalRows,
                        this.pageSize,
                        true,
                        true,
                        this.action
                    );
                    this.getDisplayOptionsSummaryData();
                    this.hasData = true;
                    this.isInitialLoading = false;

                    if (this.calculateAggregation) {
                        this.footerObject = Object.assign({}, { footerSummary: [] });
                        this.setAggregation();
                    }
                    this.calculateAggregation = true;
                } else {
                    this.updateGridView([], 0, 0, false, true, this.action);
                }
            },
            () => {
                this.hasData = false;
                this.customTableInfo.dataSet = [];
                this.customTableInfo.paginationOptions.totalRecords = 0;
                this.customTableInfo = this._reportingService.refreshCustomMatTable(
                    this.customTableInfo,
                    false,
                    true,
                    NoDataActionType.error,
                    this.searchedValue
                );
            }
        );
    }

    // ToDo: Check the purpose of this function
    getDisplayOptionsSummaryData() {
        let tempOptionalSummaryList = [];
        this.exportHeaderSummaryData = [];
        // NOTE: /reporting/pipeline/loans-on-lo-desk summary is temp disabled. Remove the dashes to re-add
        //if (this.reportUrl === '-----/reporting/pipeline/loans-on-lo-desk-----') {
        //    // TODO: if these calculations are used in other DDL reports, make this section reusable, by passing as page parameters
        //    // TODO: Veryfy the calculations
        //    let unassignedLoans = this.filteredData.filter(
        //        (item) =>
        //            (item.employee == null || item.employee == '') &&
        //            (item.loanNumber != null || item.loanNumber != '')
        //    );
        //    let assignedLoans = this.filteredData.filter(
        //        (item) =>
        //            (item.employee != null || item.employee != '') &&
        //            (item.loanNumber != null || item.loanNumber != '')
        //    );
        //    let originatorsCount = this._reusableFunctions.getUniqueItemList(
        //        assignedLoans,
        //        'employee'
        //    ).length;
        //    let totalLoans = assignedLoans.length + unassignedLoans.length;

        //    tempOptionalSummaryList.push(
        //        {
        //            title: 'Processors:',
        //            value: originatorsCount.toString(),
        //        },
        //        {
        //            title: 'Loans Unassigned:',
        //            value: unassignedLoans.length.toString(),
        //        },
        //        {
        //            title: 'Avg Loans / Processor:',
        //            value: ((totalLoans * 1.0) / originatorsCount).toFixed(2),
        //        },
        //        {
        //            title: 'Loans With Processor Assignment:',
        //            value: assignedLoans.length.toString(),
        //        }
        //    );
        //    this.optionalSummaryList = tempOptionalSummaryList;
        //}

        if (this.pageProperties.displayoptionAreaSummaryItems) {
            for (let optItem of this.pageProperties.displayoptionAreaSummaryItems) {
                if (optItem.getValueFrom === 'dateRange') {
                    this._displayOptionsService
                        .getDateRanges(
                            this.moduleName,
                            optItem.getValueFromParam,
                            'Previous Period',
                            ''
                        )
                        .subscribe(
                            (dateList) => {
                                let value = '';
                                let valueFromKeys = optItem.valueFromKeys.split(',');
                                valueFromKeys.forEach((key, index) => {
                                    let date = Object.assign(
                                        {},
                                        dateList.find((item) => item.tag === key.trim())
                                    );
                                    if (date && date.dateFullDescription) {
                                        value +=
                                            (index > 0 ? ' - ' : '') +
                                            formatDate(
                                                date.dateFullDescription,
                                                'MM/dd/yyyy',
                                                'en-US',
                                                'UTC'
                                            );
                                    }
                                });
                                tempOptionalSummaryList.push({
                                    title: optItem.title,
                                    value: value,
                                });
                                this.optionalSummaryList = tempOptionalSummaryList;
                            },
                            (error) => {
                                throw error;
                            }
                        );
                }
            }
        }
        this.exportHeaderSummaryData = this._displayOptionsService.updateExportSummaryList(
            this.reportUrl,
            this.optionalSummaryList
        );
    }

    exportToPdf() {
        this._reportExportService.addExport(
            this.requiredProperties,
            this.pageHeadline.pageTitle,
            'pdf'
        );
    }

    exportToExcel() {
        if (!this.downloadingExcel) {
            this._reportExportService.addExport(
                this.requiredProperties,
                this.pageHeadline.pageTitle,
                'excel'
            );
            this.downloadingExcel = true;
        }
        //this.exportToExcelDirectApi();
    }

    exportToExcelDirectApi() {
        let dateTime = this._reusableFunctions.getCurrentDateTimeStamp();
        let reportName = this.requiredProperties.reportId + '_' + dateTime + '__.xlsx';
        let toastId = new Date().getTime();
        this._toastService.info(
            `${reportName} export is being prepared now. When it's ready, a message will appear and the file will be automatically downloaded.`,
            {
                timeout: 10000,
            },
            toastId
        );
        this.downloadingExcel_1 = true;
        this._reportingService
            .reportExportTo(this.requiredProperties, this.baseApiUrl, this.headers)
            .subscribe({
                next: (res) => {
                    if (res) {
                        let type =
                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

                        let encoder = new TextEncoder();
                        let byteArray = encoder.encode(res);

                        let file = new Blob([byteArray], { type: type });
                        saveAs(file, reportName);
                        //saveAs(res, reportName);

                        //let file = JSON.parse(res);
                        //console.log(file);
                        //let encoder = new TextEncoder();
                        //let byteArray = encoder.encode(file['FileContents']);
                        //saveAs(new Blob([byteArray], {type: type}), reportName);

                        if (reportName) {
                            this._toastService.removeIfExists(toastId);
                        }
                        this.downloadingExcel_1 = false;
                        this._toastService.success(`${reportName} export has finished downloading`);
                    } else {
                    }
                },
                error: (error) => {
                    this.downloadingExcel_1 = false;
                    this._toastService.warning(`Something went wrong downloading ${reportName}`);
                },
            });
    }

    // exportToCsv() {
    //     this._reportExportService.addExport(
    //         this.requiredProperties,
    //         this.pageHeadline.pageTitle,
    //         'excel'
    //     );
    // }

    searchRows(event) {
        if (this.timeOutHolder) {
            clearTimeout(this.timeOutHolder);
        }
        this.resetSummaryLine();
        this.timeOutHolder = setTimeout(() => {
            this.skip = 0;
            this.searchedValue = event;
            this.isFirstDataRequest = '0';
            this.action = NoDataActionType.search;
            this.checkAccessThenGetData();
        }, 1000);
    }

    resetSummaryLine() {
        this.footerObject = Object.assign({}, { footerSummary: [] });
    }

    getInitialSorting() {
        this.sort = [];
        this.columnsProperties.forEach((item) => {
            if (item.isSortable && item.defaultSorting) {
                if (item.fieldId === 'bookmark') {
                    this.sort.splice(0, 0, {
                        field: item.fieldId,
                        dir: item.defaultSorting,
                        dataType: item.dataType,
                    });
                } else {
                    this.sort.push({
                        field: item.fieldId,
                        dir: item.defaultSorting,
                        dataType: item.dataType,
                    });
                }
            }
        });
    }

    updateGridView(
        gridData: IReportingCommon[],
        totalRows: number,
        pageSize: number,
        hasData: boolean,
        isDataReady: boolean,
        action: NoDataActionType
    ) {
        this.customTableInfo.dataSet = gridData;
        this.customTableInfo.paginationOptions.totalRecords = totalRows;
        this.customTableInfo.paginationOptions.pageSize = pageSize;
        this.customTableInfo.title = this.pageHeadline.pageTitle;
        this.customTableInfo = this._reportingService.refreshCustomMatTable(
            this.customTableInfo,
            hasData,
            isDataReady,
            action,
            this.searchedValue
        );
    }

    sortChangeEvent(sortEvent: Sort[]) {
        this.calculateAggregation = false;
        this.calculateAggregationAws = false;
        this.sort = [];
        if (this.gridData.length > 0) {
            sortEvent.forEach((item) => {
                let columnInf = this.columnsProperties.find((col) => col.fieldId === item.active);
                this.sort.push({
                    field: item.active,
                    dir: item.direction,
                    dataType: columnInf.dataType,
                });
            });
            this.isFirstDataRequest = '0';
            this.checkAccessThenGetData();
        }
    }

    pageChangeEvent(event: PageEvent) {
        this.calculateAggregation = false;
        this.calculateAggregationAws = false;
        this.pageSize = event.pageSize;
        // TODO: reset skip if the page size is changed.
        this.skip = event.pageIndex * event.pageSize;
        this.isFirstDataRequest = '0';
        this.checkAccessThenGetData();
    }

    contentChanged(rows: IReportingCommon[]) {}

    cellClickedEvent(event: ICellClickEventInfo) {
        if (event && event.columnInfo) {
            let columnInfo = event.columnInfo;
            let cellData = event.cellData as IReportingCommon;

            if (columnInfo.cellClickEventType === 'bookmark') {
                this.clickBookmark(cellData);
            } else if (columnInfo.cellClickEventType === 'hyperlink') {
                this.hyperLinkHandler(columnInfo, cellData);
            }
        }
    }

    clickBookmark(dataItem: IReportingCommon) {
        let keys = Object.keys(dataItem);
        let hasLoanNumber = false;
        let loanNumberKey = 'loanNumber';
        // TODO: look for better solution to find diffrent loanNumber key
        if (keys.find((item) => item === loanNumberKey)) {
            hasLoanNumber = true;
        } else if (keys.find((item) => item === 'loan')) {
            loanNumberKey = 'loan';
            hasLoanNumber = true;
        }
        let oldBookmark = dataItem.bookmark;
        dataItem.bookmark = !dataItem.bookmark;

        if (hasLoanNumber) {
            this._bookmarkService
                .changeLoanBookmarkStatus(dataItem[loanNumberKey], null, dataItem.bookmark)
                .subscribe(
                    (result) => {
                        if (result < 1) {
                            dataItem.bookmark = oldBookmark;
                        }
                    },
                    (error) => {
                        throw error;
                    }
                );
        }
    }

    getIndicatoricon(value) {
        let icon =
            value > 0 ? 'fas fa-caret-up' : value < 0 ? 'fas fa-caret-down' : 'fas fa-caret-right';
        return icon;
    }

    applyDisplayOptions(event: DisplayOptions[]) {
        this.action = NoDataActionType.filter;
        this.hasDisplayOptChange = true;
        if (this.finAAGModalPage) this.getPageHeadLine(this.getRouterParameters()['titleSuffix']);
        this.setPageProperties(event);
        this.resetPage();
    }

    applyNewFilters() {
        this.action = NoDataActionType.filter;
        this.setPageProperties();
        this.resetPage();
    }

    resetPage() {
        this.redisId = this._reusableFunctions.getGuid();
        this.gridData = [];
        this.resetSummaryLine();
        this.updateGridView(this.gridData, 0, 0, false, false, NoDataActionType.filter);
        this.isFirstDataRequest = '1';
        this.checkAccessThenGetData();
    }

    hyperLinkHandler(fieldInfo: ITableColumns, dataItem: IReportingCommon) {
        if (fieldInfo.modalName === 'loanDetails') {
            this.openLoanDetailsModal(dataItem, fieldInfo);
        } else if (fieldInfo.modalName === 'subReport') {
            let oldUrl = this._router.url;
            this._router.navigate([''], { replaceUrl: true }).then(() => {
                // TODO: make this section more dynamic
                this._router.navigate(['/reporting/financials/compensation_subReport'], {
                    queryParams: {
                        employeeIdentifier: dataItem[fieldInfo.hyperLinkTo_FieldId],
                        csBranch: dataItem.csBranch,
                        payDate: dataItem.payDate,
                        commType: dataItem.payType,
                        navFromUrl: oldUrl,
                    },
                    replaceUrl: true,
                });
            });
        } else if (fieldInfo.isHierarchyEntity) {
            this._router.navigate(['directory/record/'], {
                queryParams: { identifier: dataItem[fieldInfo.hyperLinkTo_FieldId] },
            });
        } else if (fieldInfo.isEmployee) {
            this._router.navigate(['settings/employees/'], {
                queryParams: { id: dataItem[fieldInfo.hyperLinkTo_FieldId] },
            });
        }
    }

    private openLoanDetailsModal(dataItem: IReportingCommon, fieldInfo: ITableColumns) {
        let param = dataItem[fieldInfo.fieldId];
        let modalName = fieldInfo.modalName;
        this.clickedLoanInfoRow = { rowData: dataItem, rowInfo: fieldInfo };

        let loanNumbers = this.gridData.map((x) => (x.loanNumber ? x.loanNumber : x.loan));

        let index = loanNumbers.findIndex((loanNumber) => loanNumber === param);
        this._listOfLoansService.changeListOfLoans({
            loanNumbers: loanNumbers,
            index: index,
        });
        let routerParams = this.getRouterParameters();
        delete routerParams['bookmarkValue'];
        delete routerParams['isLoanDetails'];
        this._router.navigate([{ outlets: { modal: modalName + '/' + param } }], {
            queryParams: routerParams,
        });
    }

    formatDates() {
        this.columnsProperties.forEach((column) => {
            if (column.dataType === 'date') {
                this.gridData.map((dataLine) => {
                    dataLine[column.fieldId] = dataLine[column.fieldId]
                        ? formatDate(dataLine[column.fieldId], 'MM/dd/yyyy', 'en-US', 'UTC')
                        : dataLine[column.fieldId];
                });
            }
        });
    }

    checkForLoanDetailsDialogChange() {
        this._activatedRoute.queryParamMap.subscribe(
            (params) => {
                let bookmarkValue = params.get('bookmarkValue');
                if (
                    this.clickedLoanInfoRow &&
                    params.get('isLoanDetails') === 'true' &&
                    bookmarkValue
                ) {
                    let rowData = this.clickedLoanInfoRow.rowData;
                    let fieldid = this.clickedLoanInfoRow.rowInfo.fieldId;
                    rowData.bookmark =
                        bookmarkValue === 'true'
                            ? true
                            : bookmarkValue === 'false'
                            ? false
                            : rowData.bookmark;
                    // TODO: check this code functionality with new changes
                    //let selectValue = this.filteredData.find(
                    //    (item) => item[fieldid] === rowData[fieldid]
                    //);
                    let selectValue = this.gridData.find(
                        (item) => item[fieldid] === rowData[fieldid]
                    );
                    selectValue.bookmark = rowData.bookmark;
                    this.updateGridView(
                        this.gridData,
                        this.totalRows,
                        this.pageSize,
                        true,
                        true,
                        NoDataActionType.pageStart
                    );
                }
            },
            (error) => {
                throw error;
            }
        );
    }

    openScheduleBuilder() {
        let scheduleData = {
            reportName: this.pageHeadline.pageTitle,
            reportId: this.reportName,
            routerParams: this.fromRouteDisplayOptionParameters,
            optionalSummaryList: this.optionalSummaryList,
            displayOptionsToReset: this.displayOptionsToReset,
            filters: this.requiredProperties,
            module: this.moduleName,
        };

        let dialogRef = this._dialog.open(ScheduleReportBuilderComponent, {
            data: scheduleData,
            maxWidth: '800px',
            width: '800px',
        });
    }

    testClick() {
        this.downloadingTestExport = true;
        this._reportingService
            .getTestReportExport(this.requiredProperties, 'excel')
            .subscribe((res) => {
                let dateTime = this._reusableFunctions.getCurrentDateTimeStamp();
                let reportName =
                    this.requiredProperties.reportId + '_test' + '_' + dateTime + '_.xlsx';
                saveAs(res, reportName);
                console.log(res);
                this.downloadingTestExport = false;
            });
    }

    onExcelExport(event) {}

    openEditReportDialog() {
        let data: IReportEditData = {
            columnsProperties: this.columnsPropertiesOriginal,
        };
        let dialogRef = this._dialog.open(ReportEditDialogComponent, {
            data: data,
            minWidth: '400px',
            minHeight: '300px',
        });

        dialogRef.afterClosed().subscribe(
            (res: IColoumnSelectionInfo) => {
                if (res) {
                    let selectedColumns: ISelectedColumns[] = [];
                    res.selectedColumns?.map((col, index) => {
                        col.fieldOrder = index;
                    });
                    this.columnsPropertiesOriginal.map((obj) => {
                        let selectedCol = res.selectedColumns?.find(
                            (col) => col.fieldId === obj.fieldId
                        );
                        if (selectedCol) {
                            obj.isSelected = true;
                            obj.fieldOrder = selectedCol.fieldOrder;

                            selectedColumns.push({
                                reportId: this.reportName,
                                fieldId: selectedCol.fieldId,
                                columnOrder: selectedCol.fieldOrder,
                            });
                        } else {
                            obj.isSelected = false;
                        }
                    });

                    this._reportingService
                        .updateSelectedColumns(selectedColumns)
                        .subscribe((numOfRowsSaved) => {
                            if (numOfRowsSaved > 0) {
                                this._toastService.success('Columns updated!');
                                this.setColumnProperties();
                            } else {
                                this._toastService.warning('No record is updated. Please check.');
                            }
                        });
                }
            },
            (error) => {}
        );
    }

    ngOnDestroy() {
        /*
        this.requiredProperties.isFirstDataRequest = '-1';
        this.requiredProperties.hasDownloadRequested = this.downloadingExcel_1;

        this._reportingService
            .removeCachedData(this.requiredProperties, this.baseApiUrl, this.headers)
            .subscribe();
        */
        //let timeOut = 0;
        //if (this.downloadingExcel_1) {
        //     timeOut = 30000;
        // }
        //setTimeout(() => {
        //     this._reportingService
        //         .removeCachedData(this.requiredProperties, this.baseApiUrl, this.headers)
        //         .subscribe();
        // }, timeOut);
    }
}
